/**
 * Custom action type for MatTableGenerato
 * If you nead more then view, edit, delete
 */
export class AppMatCustomAction {
  /**
   * @param icon Icon for action
   * @param multiselectAction Boolean that indicates if the action is available for rows selected in multiselect
   * @param event Event on click
   * @param iconTitle Title that appears onHover
   * @param disabled Disable the button
   * @param customIcon
   */
    constructor(
      public icon: string,
      public iconTitle: string,
      public multiselectAction: boolean,
      public event: ( name: any ) => void,
      public disabled: (data: any) => boolean = () => false,
      public customIcon: boolean = false,
    ) { }
  }
